import '../jquery'

let ready_mass_sms_variables;

ready_mass_sms_variables = function () {
  return $("body").on("change", ".mass_sms_message_form select#variables", function () {
    let cursor, form, input, input_val, new_cursor, result_val;
    if ($(this).val().length) {
      form = $(this).parents('.mass_sms_message_form');
      input = $(form).find('textarea.mass_sms_message_field');
      cursor = $(input).prop('selectionStart');
      input_val = input.val();
      result_val = input_val.slice(0, cursor) + $(this).val() + input_val.slice(cursor);
      input.val(result_val);
      new_cursor = cursor + $(this).val().length;
      $(input).focus();
      $(input).prop({
        'selectionStart': new_cursor,
        'selectionEnd': new_cursor
      });
      return massSmsUpdateMessageCharCount(form);
    }
  });
};

$(document).ready(ready_mass_sms_variables);

$(document).on('turbo:load', ready_mass_sms_variables);
